import Button from '@components/Button';
import useProject from '@hooks/useProject';
import useScript from '@hooks/useScript';
import {
  useId, useRef, useState,
} from 'react';
import Skeleton from 'react-loading-skeleton';

import useMap from './hooks/useMap';
import useMarkers from './hooks/useMarkers';
import LocationIcon from './LocationIcon';
import styles from './styles.module.scss';

interface Props {
    center: LatLng;
    zoom?: number;
    markers?: MarkerProps[];
    width?: string | number;
    height?: string | number;
    onMarkerClick?: (id?: string, lat?: number, lng?: number) => void;
    onBoundChange?: (props:{neLon: number, neLat: number, swLon: number, swLat: number, lat: number, lng: number}) =>void;
    showMyLocation?: boolean;
}

function Map({
  center, zoom = 13, width = '100%', markers, onMarkerClick, height, onBoundChange,
  showMyLocation,
}: Props) {
  const id = useId();
  const mapRef = useRef<inavi.maps.Map>(null);
  const [isMapLoad, setIsMapLoad] = useState<boolean>(false);
  useMap({
    mapRef, setIsMapLoad, isMapLoad, zoom, center, id, onBoundChange, showMyLocation,
  });
  useMarkers({
    mapRef, markers, isMapLoad, onMarkerClick,
  });
  const reCenterMap = () => {
    mapRef.current?.setCenter({ lat: center.lat, lng: center.lng });
  };
  const project = useProject();
  useScript({
    src: `https://imaps.inavi.com/maps/v3.0/appkeys/${project?.mapApiKey}/maps?callback=initMap`,
    enabled: !!project?.mapApiKey,
  });
  return (
      <div className={styles.wrapper}>
          <div className={styles.container}
               style={{ height, minHeight: height, maxHeight: height }}>
              <div id={id} style={{
                width,
                height,
                minHeight: height,
                maxHeight: height,
              }}/>
              {(!isMapLoad) && (
                  <div className={styles.skeleton} >
                      <Skeleton width='100%' height='100%' count={1}/>
                  </div>
              )}
          </div>
          {showMyLocation && (
              <Button size='sm' className={styles.locationButton}
                      onClick={reCenterMap} >
                  <LocationIcon/>
                  내 위치 확인
              </Button>
          )}
      </div>
  );
}

export default Map;
